import React, { useEffect, useState } from 'react';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const updateCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      
      // Add particle trail
      if (Math.random() > 0.7) {
        const newParticle = {
          id: Date.now() + Math.random(),
          x: e.clientX,
          y: e.clientY,
        };
        setParticles(prev => [...prev, newParticle].slice(-8));
      }
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (target.tagName === 'BUTTON' || target.tagName === 'A' || target.closest('button') || target.closest('a')) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };

    window.addEventListener('mousemove', updateCursor);
    window.addEventListener('mouseover', handleMouseOver);

    return () => {
      window.removeEventListener('mousemove', updateCursor);
      window.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);

  // Clean up old particles
  useEffect(() => {
    const timer = setInterval(() => {
      setParticles(prev => prev.slice(1));
    }, 150);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <style>{`
        * {
          cursor: none !important;
        }
        
        .custom-cursor {
          position: fixed;
          pointer-events: none;
          z-index: 9999;
          mix-blend-mode: difference;
        }
        
        .cursor-ring {
          position: absolute;
          width: 32px;
          height: 32px;
          border: 2px solid #00FFD1;
          border-radius: 0px;
          top: -16px;
          left: -16px;
          transition: transform 0.15s ease-out, width 0.15s ease-out, height 0.15s ease-out;
        }
        
        .cursor-ring.hovering {
          width: 48px;
          height: 48px;
          top: -24px;
          left: -24px;
          border-color: #00FFD1;
          box-shadow: 0 0 20px rgba(0, 255, 209, 0.4);
        }
        
        .cursor-dot {
          position: absolute;
          width: 6px;
          height: 6px;
          background: #00FFD1;
          top: -3px;
          left: -3px;
          box-shadow: 0 0 10px rgba(0, 255, 209, 0.8);
        }
        
        .cursor-particle {
          position: fixed;
          width: 4px;
          height: 4px;
          background: rgba(0, 255, 209, 0.4);
          border-radius: 50%;
          pointer-events: none;
          z-index: 9998;
          animation: particleFade 0.6s ease-out forwards;
        }
        
        @keyframes particleFade {
          to {
            opacity: 0;
            transform: scale(0.5);
          }
        }
        
        .cursor-crosshair-line {
          position: absolute;
          background: #00FFD1;
          opacity: 0.3;
        }
        
        .crosshair-h {
          width: 20px;
          height: 1px;
          top: -0.5px;
          left: -26px;
        }
        
        .crosshair-v {
          width: 1px;
          height: 20px;
          left: -0.5px;
          top: -26px;
        }
      `}</style>
      
      <div 
        className="custom-cursor" 
        style={{ 
          left: `${position.x}px`, 
          top: `${position.y}px` 
        }}
      >
        <div className={`cursor-ring ${isHovering ? 'hovering' : ''}`}>
          <div className="cursor-crosshair-line crosshair-h" />
          <div className="cursor-crosshair-line crosshair-v" />
        </div>
        <div className="cursor-dot" />
      </div>
      
      {particles.map(particle => (
        <div
          key={particle.id}
          className="cursor-particle"
          style={{
            left: `${particle.x}px`,
            top: `${particle.y}px`,
          }}
        />
      ))}
    </>
  );
};

export default CustomCursor;